import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { UIProvider } from "./lib/theme";
import "./globals.css";

const root = document.getElementById("root");
if (!root) throw new Error("No se encontró #root");

// UIProvider en la raíz: el tema/idioma y `useUI` están disponibles en TODA la app
// (landing, panel y el easter egg Konami), no solo dentro del Dashboard.
createRoot(root).render(
  <StrictMode>
    <UIProvider>
      <App />
    </UIProvider>
  </StrictMode>,
);
